import { Box, Button, Stack } from "@mui/material";
import AppraisalCycleCard from "./AppraisalCycleCard";
import MotionWrapper from "../../../../../components/MotionWrapper";
import CreateNewCycle from "./CreateNewCycle";
import { useEffect, useState } from "react";
import DeleteCycle from "./DeleteCycle";
import ManageUser from "./ManageUser";
import CloneCycle from "./CloneCycle";
import { useSelector, useDispatch } from "react-redux";
import { getAllEvaluationcycle } from "../../../../../redux/features/appraisalSlice";
import StartCycle from "./StartCycle";
import { getAllUsersNew } from "../../../../../redux/features/generalSlice";
import CycleStatus from "./CycleStatus";
import ManageAppraisal from "./ManageAppraisal";
import RestartCycle from "./RestartCycle";

const AppraisalCycle = () => {
  const dispatch = useDispatch();
  const { evaluationData } = useSelector((state) => state.appraisal);
  const [filteredData, setFilteredData] = useState([]);
  const [active, setActive] = useState(0);
  const [deleteCycle, setDeleteCycle] = useState(false);
  const [manageUser, setManageUser] = useState(false);
  const [clone, setClone] = useState(false);
  const [currentData, setCurrentData] = useState({});
  const [runCycle, setRunCycle] = useState(false);
  const [restartcycle , setRestartCycle] = useState(false)
  const [createCycle, setCreateCycle] = useState(false);
  const [editStatus, setEditStatus] = useState(false);
  const [status, setStatus] = useState(false);
  const [manage, setManage] = useState(false);
  const handleCurrentData = (data) => {
    setCurrentData(data);
  };

  useEffect(() => {
    dispatch(getAllEvaluationcycle());
    dispatch(getAllUsersNew());
  }, []);

  // Filter data based on active state
  const filterCycles = (status) => {
    const result = evaluationData.filter((item) =>
      status === 0
        ? item.cycle_status === status || item.cycle_status === 1
        : item.cycle_status === status
    );
    setFilteredData(result);
    setActive(status);
  };

  useEffect(() => {
    filterCycles(0);
  }, [evaluationData]);

  return ( 
    <Box>
      {/* Top Right Button */}
      <Box sx={{ display: "flex", justifyContent: "flex-end", mb: 2 }}>
        <CreateNewCycle
          update={editStatus}
          setOpen={setCreateCycle}
          open={createCycle}
          setEditStatus={setEditStatus}
          id={currentData.appraisal_cycle_id}
        />
      </Box>

      {/* Filter Buttons */}
      <Stack direction="row" spacing={2} mb={3}>
        <Button
          variant={active === 0 ? "contained" : "outlined"}
          sx={{ borderRadius: 3 }}
          size="small"
          onClick={() => filterCycles(0)}
        >
          Active Cycle
        </Button>
        <Button
          variant={active === 2 ? "contained" : "outlined"}
          sx={{ borderRadius: 3 }}
          size="small"
          onClick={() => filterCycles(2)}
        >
          Completed Cycle
        </Button>
      </Stack>

      {/* Render Cards */}
      {filteredData.length > 0 ? (
        filteredData.map((item, i) => (
          <Box key={item.id || i} mb={2}>
            <MotionWrapper direction="top" delay={i * 0.1}>
              <AppraisalCycleCard
                setDeleteCycle={setDeleteCycle}
                setManageUser={setManageUser}
                setRunCycle={setRunCycle}
                setClone={setClone}
                data={item}
                handleCurrentData={handleCurrentData}
                setCreateCycle={setCreateCycle}
                setEditStatus={setEditStatus}
                setStatus={setStatus}
                setManage={setManage}
                setRestartCycle={setRestartCycle}
              />
            </MotionWrapper>
          </Box>
        ))
      ) : (
        <Box textAlign="center" mt={4}>
          No appraisal cycles found.
        </Box>
      )}
      <DeleteCycle
        open={deleteCycle}
        setOpen={setDeleteCycle}
        id={currentData.appraisal_cycle_id}
      />
      <ManageUser
        status={currentData.cycle_status}
        id={currentData.appraisal_cycle_id}
        open={manageUser}
        setOpen={setManageUser}
      />
      <CloneCycle
        open={clone}
        setOpen={setClone}
        id={currentData.appraisal_cycle_id}
      />
      <CycleStatus
        status={currentData.cycle_status}
        open={status}
        setOpen={setStatus}
        currentData={currentData}
        id={currentData.appraisal_cycle_id}
      />
      <ManageAppraisal
        id={currentData.appraisal_cycle_id}
        cycleName={currentData?.appraisal_cycle_name}
        open={manage}
        setOpen={setManage}
      />
      <StartCycle data={currentData} open={runCycle} setOpen={setRunCycle} />
      <RestartCycle data={currentData} open={restartcycle} setOpen={setRestartCycle}/>
      {currentData && currentData.title}
    </Box>
  );
};

export default AppraisalCycle;
